<template>
  <div class="about-page">
    <!-- 头部导航 -->
    <Header v-if="imglist != ''"/>

    <!-- 轮播图区域 -->
    <div v-if="imglist != ''">
      <img
        :src="imglist.banner[0].thumb"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="company-intro" v-if="imglist != ''">
      <!-- 导航栏 -->
      <el-menu
        mode="horizontal"
        :default-active="activeIndex"
        class="gradient-nav"
      >
        <el-menu-item
          index="1"
          v-for="(item, index) in list"
          :key="index"
          :style="'width: ' + 100 / list.length + '%'"
          @click="goto(item)"
          >{{ item.name }}</el-menu-item
        >
      </el-menu>

      <!-- 内容区域 -->
      <div class="content">
        <div style="width: 800px; margin: 0 auto">
          <h2 class="section-title">{{ imglist.vo.name }}</h2>

          <!-- 公司介绍文本（按需替换为真实内容） -->
          <div v-html="imglist.vo.description"></div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <Footer v-if="imglist != ''"/>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsDetail } from "@/api/index";
export default {
  name: "About",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      activeIndex: "1", // 默认选中“公司介绍”
      carouselHeight: "50vh", // 默认高度为视口的50%
      imglist: "",
      list:[],
      list1: [
        {
          name: "公司介绍",
          type: 1,
          id: 1,
        },
        {
          name: "董事长致辞",
          type: 1,
          id: 2,
        },
        {
          name: "企业文化",
          type: 1,
          id: 3,
        },
        {
          name: "企业荣誉",
          type: 2,
          id: 6,
        },
        {
          name: "研发实力",
          type: 1,
          id: 4,
        },
      ],
       list2: [
        {
          name: "保健食品",
          type: 2,
          id: 11,
        },
        {
          name: "保健器材",
          type: 2,
          id: 12,
        },
        {
          name: "化妆品",
          type: 2,
          id: 13,
        },
        {
          name: "保洁用品",
          type: 2,
          id: 14,
        },
      ],
      list3: [
        {
          name: "爱心活动",
          type: 2,
          id: 8,
        },
        {
          name: "社会荣誉",
          type: 2,
          id: 9,
        },
      ],
      obj: {
        id: "",
        unit_id: "",
      },
    };
  },
  mounted() {
    // console.log(id, unit_id);
    // let obj = {
    //   id: "",
    //   unit_id: "",
    // };
    this.obj.id = this.$route.query.id;
    this.obj.unit_id = this.$route.query.unit_id;
    console.log(this.$route.query.uid);
    if (this.obj.unit_id==3) {
        this.list = this.list2
    } else if(this.obj.unit_id==4){
       this.list = this.list3
    }else if(this.$route.query.show == 0){
        this.list = []
    }else if(this.obj.unit_id==1||this.obj.unit_id==2){
       this.list = this.list1
    }
    
    this.getNewsDetail(this.obj);
  },
  methods: {
    goto(item) {
      this.obj.id = item.id;
      
      if (item.type == 1) {
        this.getNewsDetail(this.obj); // 将id拼接到路由路径中
      } else {
        this.$router.push({
          path: `/news?id=${item.id}&unit_id=${this.obj.unit_id}`, // 将id拼接到路由路径中
        });
      }
    },
    //获取详情
    getNewsDetail(obj) {
      console.log(1111);

      NewsDetail(obj).then((res) => {
        console.log(res);
        this.imglist = res;
      });
    },
  },
};
</script>

<style scoped>
/* 导航栏整体：线性渐变背景 */
.gradient-nav {
  background: linear-gradient(
    to right,
    #e6ddce,
    #c4a35f
  ); /* 从浅棕到深棕的渐变 */
  border: none !important; /* 移除 Element UI 默认边框 */
}

/* 菜单项基础样式 */
.gradient-nav .el-menu-item {
  color: #554422 !important; /* 文字颜色 */
  height: 65px !important;
  line-height: 65px !important;
  border: none !important; /* 移除默认边框 */

  font-size: 25px;
  padding: 16px 0;
}

/*  hover 状态 */
.gradient-nav .el-menu-item:hover {
  background-color: rgba(
    255,
    255,
    255,
    0.2
  ) !important; /* 半透明白色 hover 背景 */
}

/* 激活（选中）状态 */
.gradient-nav .el-menu-item.is-active {
  background-color: rgba(
    255,
    255,
    255,
    0.3
  ) !important; /* 激活时更明显的半透背景 */
  color: #333 !important; /* 激活时文字加深 */
  width: 20%;
}

.company-intro {
  color: #333;
  line-height: 1.8;
  background-color: #f6f6f6;
}

/* 顶部横幅 */
.top-banner {
  background: url("http://www.foherb.cn/uploads/ads/8/img/IAx2UikGs7BPw0iL.jpg")
    no-repeat center center;
  background-size: cover;
  padding: 40px 20px;
  text-align: center;
  color: #fff;
  height: 400px;
  min-width: 870px;
}

/* 导航栏 */
.el-menu--horizontal {
  margin-bottom: 50px;
  border-bottom: none;
  width: 1100px;
  margin-right: auto;
  margin-left: auto;
}

.el-menu-item {
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;
}

/* 内容区 */
.content {
  max-width: 1100px;
  margin: 0 auto;
  background-color: #fff;
}

.section-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

h3 {
  text-align: left;
  color: #666;
  margin: 15px 0;
}

p {
  text-align: left;
  margin: 10px 0;
  text-indent: 2em; /* 首行缩进2字符 */
}

/* 底部图片 */
.bottom-img {
  width: 100%;
  height: auto;
}
</style>
